export enum ExternalLinksZIndexes {
    OmgBehindTheGame= 8035,
    GameFrame = 8040,
    MyAccount = 8060,
    InternalOverExternalLink= 8065,
    Omg = 8070,
    Cashier = 8072,
    GeoProgressIndicator = 8074,
    Membership = 8078,
    PendingAction = 8085,
    TouchID = 8090,
    BurnOutAnimation = 8082
}